export class WaitForDocumentationRequiredTimeoutException extends Error {
  constructor() {
    super('WaitForDocumentationRequiredTimeoutException');
  }
}
